import { columns } from "../../../../dtos/columns";
import { MutuosARecaudar } from "../../../endosos/endososPsm/models/mutuosARecaudar";
import { Checkbox } from "@mui/material";
import { RowGeneracionSII } from "../models/rowGeneracionSII";
import { format } from "rut.js";
import AccionesSII from "../components/accionesSII";
import { numericFormatter } from "react-number-format";

interface IProps{
    generarCertificadoIndividual: (e: number) => void
}

export function UseColumns({generarCertificadoIndividual} : IProps){

    const COLUMNS: columns<RowGeneracionSII>[] = [
        {
            name: 'Acciones',
            selector: (row: RowGeneracionSII) => '',
            cell: (row: RowGeneracionSII) => //row.estado != "Por Ingresar" ?
                <AccionesSII 
                    filaSii={row}
                    generarCertificadoIndividual={generarCertificadoIndividual}
                />,
            allowOverflow: true,
            button: true,
            export: false,
        },
        {
            name: 'N° operación',
            selector: (row: RowGeneracionSII) => row.numeroOperacion,
            sortable: true,
            sortField: 'numeroOperacion',
            wrap: true,
            alling: 'left',
            export: true,
        },
        {
            name: 'RUT',
            selector: (row: RowGeneracionSII) => format(row.rut),
            sortable: true,
            sortField: 'rut',
            wrap: true,
            alling: 'left',
            export: true,
        },
        {
            name: 'Nombre deudor',
            selector: (row: RowGeneracionSII) => row.nombreDeudor,
            sortable: true,
            sortField: 'nombreDeudor',
            wrap: true,
            alling: 'left',
            export: true,
        },
        {
            name: 'Tasa crédito',
            selector: (row: RowGeneracionSII) => row.tasaCredito,
            cell: (row: RowGeneracionSII) => numericFormatter(row.tasaCredito.toString(), { "thousandsGroupStyle": "thousand", "thousandSeparator": ".", "decimalSeparator": ",", "suffix": " %" }),
            sortable: true,
            sortField: 'tasaCredito',
            wrap: true,
            alling: 'left',
            export: true,
        }, 
        {
            name: 'Monto crédito',
            selector: (row: RowGeneracionSII) => row.montoCredito,
            cell: (row: RowGeneracionSII) => numericFormatter(row.montoCredito.toString(), { "thousandsGroupStyle": "thousand", "thousandSeparator": ".", "decimalSeparator": ",", "prefix": "UF " }),
            sortable: true,
            sortField: 'montoCredito',
            wrap: true,
            alling: 'left',
            export: true,
        }, 
        {
            name: 'Estado',
            selector: (row: RowGeneracionSII) => row.estado,
            sortable: true,
            sortField: 'estado',
            wrap: true,
            alling: 'left',
            export: true,
        },
    ]

    return { COLUMNS };
}